"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProcedureSchema = exports.createProcedureSchema = exports.procedureShape = void 0;
const zod_1 = require("zod");
const department_schema_1 = require("./department.schema");
exports.procedureShape = {
    procedureCode: zod_1.z.string().min(1).max(20),
    name: zod_1.z.string().min(1).max(255),
    description: zod_1.z.string().optional(),
    departmentType: department_schema_1.departmentTypeEnum.optional(),
};
exports.createProcedureSchema = zod_1.z.object(exports.procedureShape);
exports.updateProcedureSchema = exports.createProcedureSchema.partial();
//# sourceMappingURL=procedure.schema.js.map